/**
 * Intention: This store is used to track necessary and commonly accessed user settings
 * like current user language preferences etc
 */
import { useStorage } from '@vueuse/core'

export interface UserSettingsState {
  currentLanguage: string
  userRoles: Array<AccountUserRole>
}

export const useUserSettingsStore = defineStore('userSettings', {
  state(): UserSettingsState {
    return {
      currentLanguage: useLocalize().getLanguage() ?? 'en',
      userRoles: useStorage('userRoles', [], localStorage) as unknown as Array<AccountUserRole>,
    }
  },
  actions: {
    setLanguage(currentLanguage: string) {
      this.currentLanguage = currentLanguage
      useLocalize().setLanguage(currentLanguage)
    },
    setUserRoles(userRoles: Array<AccountUserRole>) {
      this.userRoles = userRoles
    },
  },
})
